<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="epigraph" style="margin-top:20px;">In the seventh century, the Toltecs, an agricultural people, moved from northern Mexico down into the vicinity of Mexico City. In all of history, there was never a people more civilized or humane. According to the old histories, the Toltecs went to war with wooden swords—so that they would not kill their enemies.</p>
<p class="right">—<b><i>The Book of Lists</i></b></p>
<p class="ind" style="margin-top:20px;">For they sleep not, except they have done mischief; and their sleep is taken away, unless they cause some to fall.</p>
<p class="ind">For they eat the bread of wickedness, and drink the wine of violence.</p>
<p class="right">—<b><i>Proverbs</i> 4:16–17</b></p>
<p class="noind" style="margin-top:20px;"><i>There was a time, believe it or not, when human beings did each other harm. In the chaotic ages preceding the Stromboli Solution, torture, rape, war, and murder happened almost daily. Violence reigned like a soulless despot. Self-defense was a growth industry.</i></p>
<p class="ind"><i>Scholars today agree that, of all the pre-Stromboli schemes for conquering aggression, only one merits preservation in our collective memory.</i></p>
<p class="ind"><i>This is the story of Quetzalia.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0-epigraph.vue?5456eb9c